function isNull(l){return null===l}module.exports=isNull;